import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import { toJS } from "mobx";
import { withAlert } from "react-alert";
import Layout from "../../components/Layout";
import store from "../../stores/expoStore";
import {
  Card,
  Typography,
  CardContent,
  CardHeader,
  CardActions,
  Button,
  Grid,
  Paper,
  Divider,
  AppBar,
  Toolbar,
} from "@material-ui/core";
import { Link } from "react-router-dom";

const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
  },
});

function ExpoCard(props) {
  const title = props.data.expoReactNativeTag;
  const androidLink = props.data.androidClientUrl;
  const iosLink = props.data.iosClientUrl;
  return (
    <Card style={{ margin: 10 }}>
      <CardHeader title={title} />
      <CardContent>
        <Typography>{title}</Typography>
      </CardContent>
      <CardActions>
        <Button>
          <a href={androidLink} target="_blank">
            Android
          </a>
        </Button>
        <Button>
          <a href={iosLink} target="_blank">
            ios
          </a>
        </Button>
      </CardActions>
    </Card>
  );
}

const View = observer(
  class expo extends React.Component {
    constructor(props) {
      super(props);
    }

    componentDidMount = async () => {};

    render() {
      const { classes } = this.props;
      const list = toJS(store.list).sdkVersions;

      return (
        <Layout>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <ExpoCard data={list["35.0.0"]} />
              <ExpoCard data={list["36.0.0"]} />
              <ExpoCard data={list["37.0.0"]} />
              <ExpoCard data={list["38.0.0"]} />
              <ExpoCard data={list["39.0.0"]} />
            </Grid>
            <Grid item xs={4}>
              <Paper>
                <AppBar position="static">
                  <Toolbar variant="dense">
                    <Typography variant="h6" color="inherit">
                      안드로이드
                    </Typography>
                  </Toolbar>
                </AppBar>
                <Divider />
                <Typography style={{ margin: 20 }}>
                  1. APK 다운로드 받아 설치합니다.
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={4} style={{ position: "relative" }}>
              <Paper>
                <AppBar position="static">
                  <Toolbar variant="dense">
                    <Typography variant="h6" color="inherit">
                      IOS
                    </Typography>
                  </Toolbar>
                </AppBar>

                <Divider />
                <Typography style={{ margin: 20 }}>
                  simulator
                  <br />
                  <br />
                  1. MAC PC에서 좌측의 ios tar.gz 파일을 다운로드 합니다.
                  <br />
                  2. 다운로드 받은 tar.gz 파일을 더블클릭 하거나 압축해제
                  합니다.
                  <br />
                  3. 압축해제된 폴더에 이름을 .app 으로 확장자를 변경합니다.
                  <br />
                  4. 설치를 원하는 시뮬레이터를 실행합니다.
                  <br />
                  5. expo client app이 존재할시 먼저 삭제합니다.
                  <br />
                  6. 터미널을 실행시킨 후 아래 명령어를 입력합니다.
                  <br />
                  xcrun simctl install booted [.app으로 바꾼 값]
                  <br />
                  ex) xcrun simctl install booted
                  /Users/imac/Downloads/Exponent-2.13.0.app
                </Typography>
                <Divider />
                <Typography style={{ margin: 20 }}>
                  device
                  <br />
                  <br />
                  1. 좌측의 ios tar.gz 파일을 다운로드 합니다.
                  <br />
                  2. 다운로드 받은 tar.gz 파일을 더블클릭 하거나 압축해제
                  합니다.
                  <br />
                  3. 압축해제된 폴더에 이름을 .app 으로 확장자를 변경합니다.
                  <br />
                  4. itunes 앱 탭에서 드래그 하여 설치합니다.
                  <br />
                  위 방법 오류시 3번까지 수행하고 ex) Expo 폴더를 생성합니다.
                  <br />
                  폴더 생성후 .app 파일을 생성한 폴더에 넣은 후 폴더를
                  압축합니다. 압축한 폴더의 확장자를 .ipa로 변경합니다.
                  <br />
                  itunes 앱 탭에서 드래그 하여 설치합니다.
                </Typography>
                <Divider />
              </Paper>
            </Grid>
          </Grid>
        </Layout>
      );
    }
  }
);

const alertView = withAlert()(View);
export default withStyles(styles)(alertView);
